import { CloudDone, DeleteOutline, OpenInNewOutlined } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import clsx from 'clsx';
import { openUrlWithNewWindow } from 'libs/uikit/src/utils/url';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var JoveCloudFileListItemView = function JoveCloudFileListItemView(props) {
  var className = props.className,
      info = props.info,
      deleteItem = props.deleteItem,
      hideDeleteButton = props.hideDeleteButton,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size;
  /**
   * methods
   */

  var deleteAction = function deleteAction() {
    deleteItem === null || deleteItem === void 0 ? void 0 : deleteItem(info);
  };

  var openFileAction = function openFileAction() {
    openUrlWithNewWindow(info.url);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('border-grey-10 flex flex-row items-center rounded-xl border', className),
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex w-0 flex-1 flex-row items-center space-x-3",
      children: [/*#__PURE__*/_jsx(Box, {
        className: clsx('bg-light-blue flex items-center justify-center rounded-lg', size === 'small' ? 'h-9 w-9' : 'h-12 w-12'),
        children: /*#__PURE__*/_jsx(CloudDone, {
          className: "text-brand-secondary"
        })
      }), /*#__PURE__*/_jsxs(Box, {
        className: "flex w-0 flex-1 flex-col",
        children: [/*#__PURE__*/_jsx(Typography, {
          className: clsx('break-words font-bold', size === 'small' ? 'text-sm' : 'text-lg'),
          children: info === null || info === void 0 ? void 0 : info.title
        }), (info === null || info === void 0 ? void 0 : info.sizeText) && /*#__PURE__*/_jsx(Typography, {
          variant: "subtitle2",
          className: "mt-1 text-xs font-medium",
          children: info === null || info === void 0 ? void 0 : info.sizeText
        })]
      })]
    }), /*#__PURE__*/_jsx(IconButton, {
      onClick: openFileAction,
      children: /*#__PURE__*/_jsx(OpenInNewOutlined, {
        className: clsx(size === 'small' ? 'h-5 w-5' : 'h-6 w-6')
      })
    }), !hideDeleteButton && /*#__PURE__*/_jsx(IconButton, {
      onClick: deleteAction,
      children: /*#__PURE__*/_jsx(DeleteOutline, {
        className: clsx(size === 'small' ? 'h-5 w-5' : 'h-6 w-6')
      })
    })]
  });
};

export default JoveCloudFileListItemView;